// import React, { useEffect, useState } from "react";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   IconButton,
//   Tooltip,
//   Chip,
//   Typography,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Box,
//   TablePagination,
//   CircularProgress,
//   Divider,
//   Stack,
//   Grid,
//   useMediaQuery,
//   useTheme,
// } from "@mui/material";

// import VisibilityIcon from "@mui/icons-material/Visibility";
// import EditIcon from "@mui/icons-material/Edit";
// import DateRangeIcon from "@mui/icons-material/DateRange";
// import configServ from "../services/config";
// import { useSelector } from "react-redux";
// import configService from "../services/config";

// const LeaveTable = ({ handleEdit, ischange }) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("md"));

//   const [selectedLeave, setSelectedLeave] = useState(null);
//   const [open, setOpen] = useState(false);
//   const [leaveData, setLeaveData] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const { company_id, userId } = useSelector(state => state.globalVariables);
 
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [total, setTotal] = useState(0);

//   const fetchLeaveData = async (currentPage, limit) => {
//     setLoading(true);
//     try {
//       const response = await configService.getLeaves({
//         company_id,
//         page: currentPage + 1,
//         per_page: limit,
//         isAdmin: false,
//         employee_id: userId,
//       });
//       if (response.status === 200) {
//         setLeaveData(response.data.data || []);
//         setTotal(response.data.total || 0);
//       }
//     } catch (error) {
//       console.log(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchLeaveData(page, rowsPerPage);
//   }, [page, rowsPerPage, ischange]);

//   // --- Light Mode Status Colors ---
//   const getStatusStyle = (status) => {
//     switch (status?.toLowerCase()) {
//       case "pending":
//         return { bg: "#fff3e0", color: "#b78103" }; // Soft Orange
//       case "approved":
//         return { bg: "#e8f5e9", color: "#2e7d32" }; // Soft Green
//       case "rejected":
//         return { bg: "#ffebee", color: "#c62828" }; // Soft Red
//       default:
//         return { bg: "#f5f5f5", color: "#616161" };
//     }
//   };

//   // --- Light Mode Card Style for Mobile ---
//   const lightCardStyle = {
//     backgroundColor: "#ffffff",
//     color: "#212121",
//     borderRadius: "12px",
//     border: "1px solid #e0e0e0",
//     p: 2,
//     boxShadow: "0px 2px 4px rgba(0,0,0,0.05)",
//     transition: "0.3s",
//     "&:hover": { 
//       boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
//       borderColor: "#bdbdbd" 
//     },
//   };

//   // --- Mobile Card View ---
//   const MobileCard = ({ row }) => {
//     const style = getStatusStyle(row.status);
//     return (
//       <Box sx={lightCardStyle}>
//         <Stack spacing={1.5}>
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "flex-start",
//             }}
//           >
//             <Box>
//               <Typography
//                 variant="subtitle1"
//                 sx={{ fontWeight: 700, color: "#212121" }}
//               >
//                 {row.employee_name}
//               </Typography>
//               <Typography variant="caption" sx={{ color: "#00838f", fontWeight: 600 }}>
//                 {row.leave_name}
//               </Typography>
//             </Box>
//             <Chip
//               label={row.status?.toUpperCase()}
//               size="small"
//               sx={{
//                 backgroundColor: style.bg,
//                 color: style.color,
//                 fontWeight: 700,
//                 borderRadius: "6px",
//               }}
//             />
//           </Box>

//           <Divider sx={{ borderColor: "#eee" }} />

//           <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//             <DateRangeIcon sx={{ fontSize: 18, color: "text.secondary" }} />
//             <Typography variant="body2" sx={{ color: "#424242" }}>
//               {row.from_date} — {row.to_date} <strong>({row.total_days} Days)</strong>
//             </Typography>
//           </Box>

//           <Typography
//             variant="body2"
//             sx={{ color: "text.secondary", fontStyle: "italic", backgroundColor: "#f9f9f9", p: 1, borderRadius: "6px" }}
//           >
//             "{row.reason || "No reason provided"}"
//           </Typography>

//           <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
//             <IconButton
//               size="small"
//               onClick={() => {
//                 setSelectedLeave(row);
//                 setOpen(true);
//               }}
//               sx={{ color: "#00bcff", backgroundColor: "#f0faff", "&:hover": { backgroundColor: "#e0f5ff" } }}
//             >
//               <VisibilityIcon fontSize="small" />
//             </IconButton>
//           </Box>
//         </Stack>
//       </Box>
//     );
//   };

//   return (
//     <Box
//       sx={{
//         width: "100%",
//         p: { xs: 1.5, md: 3 },
//         backgroundColor: "#f4f6f8", // Soft light gray background
//         minHeight: "100vh",
//       }}
//     >
//       {loading ? (
//         <Box sx={{ display: "flex", justifyContent: "center", py: 10 }}>
//           <CircularProgress />
//         </Box>
//       ) : (
//         <>
//           {isMobile ? (
//             // MOBILE GRID VIEW (1 Column on Mobile, 2 Columns on Tablet)
//             <Grid container spacing={2}>
//               {leaveData.map((row) => (
//                 <Grid item xs={12} sm={6} key={row.id}>
//                   <MobileCard row={row} />
//                 </Grid>
//               ))}
//             </Grid>
//           ) : (
//             // DESKTOP TABLE VIEW
//             <TableContainer
//               component={Paper}
//               sx={{
//                 backgroundColor: "#ffffff",
//                 borderRadius: "12px",
//                 border: "1px solid #e0e0e0",
//                 boxShadow: "0px 4px 10px rgba(0,0,0,0.03)",
//                 width: "100%",
//               }}
//             >
//               <Table>
//                 <TableHead sx={{ backgroundColor: "#f8f9fa" }}>
//                   <TableRow>
//                     {[
//                       // "Emp Name",
//                       "Type",
//                       "Reason",
//                       "Duration",
//                       "Days",
//                       "Status",
//                       "Action",
//                     ].map((h) => (
//                       <TableCell
//                         key={h}
//                         sx={{
//                           color: "text.secondary",
//                           fontWeight: 700,
//                           borderBottom: "1px solid #e0e0e0",
//                         }}
//                       >
//                         {h}
//                       </TableCell>
//                     ))}
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {leaveData.map((row) => {
//                     const style = getStatusStyle(row.status);
//                     return (
//                       <TableRow
//                         key={row.id}
//                         sx={{ "&:hover": { backgroundColor: "#fdfdfd" } }}
//                       >
//                         {/* <TableCell sx={{ color: "#212121", fontWeight: 500 }}>
//                           {row.employee_name}
//                         </TableCell> */}
//                         <TableCell sx={{ color: "#00838f", fontWeight: 600 }}>
//                           {row.leave_name}
//                         </TableCell>
//                         <TableCell sx={{ color: "#616161" }}>
//                           {row.reason ? `${row.reason.substring(0, 20)}...` : "—"}
//                         </TableCell>
//                         <TableCell sx={{ color: "#212121" }}>
//                           {row.from_date} to {row.to_date}
//                         </TableCell>
//                         <TableCell sx={{ color: "#212121", fontWeight: 600 }}>
//                           {row.total_days}
//                         </TableCell>
//                         <TableCell>
//                           <Chip
//                             label={row.status}
//                             size="small"
//                             sx={{
//                               backgroundColor: style.bg,
//                               color: style.color,
//                               fontWeight: 600,
//                               borderRadius: "6px",
//                             }}
//                           />
//                         </TableCell>
//                         <TableCell>
//                           <IconButton
//                             onClick={() => {
//                               setSelectedLeave(row);
//                               setOpen(true);
//                             }}
//                             sx={{ color: "#00bcff", "&:hover": { backgroundColor: "#f0faff" } }}
//                           >
//                             <VisibilityIcon fontSize="small" />
//                           </IconButton>
//                         </TableCell>
//                       </TableRow>
//                     );
//                   })}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//           )}

//           <TablePagination
//             component="div"
//             count={total}
//             page={page}
//             onPageChange={(e, n) => setPage(n)}
//             rowsPerPage={rowsPerPage}
//             onRowsPerPageChange={(e) => {
//               setRowsPerPage(parseInt(e.target.value, 10));
//               setPage(0);
//             }}
//             sx={{ color: "text.secondary", mt: 2 }}
//           />
//         </>
//       )}

//       {/* Details Dialog */}
//       <Dialog
//         open={open}
//         onClose={() => setOpen(false)}
//         fullWidth
//         PaperProps={{
//           sx: {
//             backgroundColor: "#ffffff",
//             color: "#212121",
//             borderRadius: "12px",
//           },
//         }}
//       >
//         <DialogTitle sx={{ borderBottom: "1px solid #e0e0e0", fontWeight: 700 }}>
//           Leave Details
//         </DialogTitle>
//         <DialogContent sx={{ p: 3 }}>
//           {selectedLeave && (
//             <Stack spacing={2} sx={{ mt: 2 }}>
//               <Box sx={{ display: "flex", justifyContent: "space-between" }}>
//                 <Typography color="text.secondary" sx={{ fontWeight: 500 }}>Employee:</Typography>
//                 <Typography sx={{ fontWeight: 600 }}>{selectedLeave.employee_name}</Typography>
//               </Box>
//               <Box sx={{ display: "flex", justifyContent: "space-between" }}>
//                 <Typography color="text.secondary" sx={{ fontWeight: 500 }}>Duration:</Typography>
//                 <Typography sx={{ fontWeight: 600 }}>
//                   {selectedLeave.from_date} to {selectedLeave.to_date} ({selectedLeave.total_days} Days)
//                 </Typography>
//               </Box>
//               <Box>
//                 <Typography color="text.secondary" sx={{ fontWeight: 500, mb: 0.5 }}>Reason:</Typography>
//                 <Typography
//                   sx={{ p: 1.5, backgroundColor: "#f5f5f5", borderRadius: "8px", border: "1px solid #e0e0e0", color: "#424242" }}
//                 >
//                   {selectedLeave.reason || "No reason provided"}
//                 </Typography>
//               </Box>
//             </Stack>
//           )}
//         </DialogContent>
//         <DialogActions sx={{ p: 2, borderTop: "1px solid #e0e0e0" }}>
//           <Button onClick={() => setOpen(false)} variant="contained" disableElevation sx={{ backgroundColor: "#f0f0f0", color: "#424242", "&:hover": { backgroundColor: "#e0e0e0" } }}>
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default LeaveTable;

import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Tooltip,
  Chip,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  TablePagination,
  CircularProgress,
  Divider,
  Stack,
  Grid,
  Skeleton,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import VisibilityIcon from "@mui/icons-material/Visibility";
import CancelIcon from "@mui/icons-material/Cancel";
import DateRangeIcon from "@mui/icons-material/DateRange";
import Swal from "sweetalert2";
import configService from "../services/config";
import { useSelector } from "react-redux";

const LeaveTable = ({ ischange }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [selectedLeave, setSelectedLeave] = useState(null);
  const [open, setOpen] = useState(false);
  const [leaveData, setLeaveData] = useState([]);
  const [loading, setLoading] = useState(false);

  const { company_id, userId } = useSelector(
    (state) => state.globalVariables
  );

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [total, setTotal] = useState(0);

  const [leaveBalances, setLeaveBalances] = useState([]);
  const [balanceLoading, setBalanceLoading] = useState(true);

  const fetchLeaveBalances = async () => {
    setBalanceLoading(true);
    try {
      const res = await configService.getMyLeaveBalance({
        company_id,
        customer_id: userId,
      });
      if (res?.status === 200) setLeaveBalances(res.data || []);
    } catch (error) {
      console.error("Error fetching leave balance:", error);
    } finally {
      setBalanceLoading(false);
    }
  };

  const fetchLeaveData = async (currentPage, limit) => {
    setLoading(true);
    try {
      const response = await configService.getLeaves({
        company_id,
        page: currentPage + 1,
        per_page: limit,
        isAdmin: false,
        customer_id: userId,
      });
      if (response.status === 200) {
        setLeaveData(response.data.data || []);
        setTotal(response.data.total || 0);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeaveData(page, rowsPerPage);
  }, [page, rowsPerPage, ischange]);

  useEffect(() => {
    fetchLeaveBalances();
  }, [company_id, userId, ischange]);

  // ---- Cancel ----
  const handleCancel = async (leave) => {
    const confirm = await Swal.fire({
      title: "Cancel Leave?",
      html: `
        <p>Are you sure you want to cancel this leave?</p>
        <p style="font-size:0.85rem;color:#666;">
          <b>Type:</b> ${leave.leave_name}<br/>
          <b>From:</b> ${leave.from_date} &nbsp; <b>To:</b> ${leave.to_date}<br/>
          <b>Days:</b> ${leave.total_days}
        </p>
      `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Cancel Leave",
      cancelButtonText: "No",
      confirmButtonColor: "#d33",
    });

    if (!confirm.isConfirmed) return;

    try {
      const res = await configService.cancelLeave(leave.id, {
        company_id,
        customer_id: userId,
      });

      if (res?.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Cancelled",
          text: res.message || "Leave cancelled successfully",
          timer: 2500,
          showConfirmButton: false,
        });
        fetchLeaveData(page, rowsPerPage);
        fetchLeaveBalances();
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: res?.message || "Failed to cancel leave",
        });
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err?.response?.data?.message || "Something went wrong!",
      });
    }
  };

  const getStatusStyle = (status) => {
    switch (status?.toLowerCase()) {
      case "pending":
        return { bg: "#fff3e0", color: "#b78103" };
      case "approved":
        return { bg: "#e8f5e9", color: "#2e7d32" };
      case "rejected":
        return { bg: "#ffebee", color: "#c62828" };
      case "cancelled":
        return { bg: "#f5f5f5", color: "#616161" };
      default:
        return { bg: "#f5f5f5", color: "#616161" };
    }
  };

  const MobileCard = ({ row }) => {
    const style = getStatusStyle(row.status);
    const canCancel = row.status?.toLowerCase() !== "cancelled";

    return (
      <Box
        sx={{
          backgroundColor: "#ffffff",
          color: "#212121",
          borderRadius: "12px",
          border: "1px solid #e0e0e0",
          p: 2,
          boxShadow: "0px 2px 4px rgba(0,0,0,0.05)",
        }}
      >
        <Stack spacing={1.5}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
            }}
          >
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                {row.employee_name || "—"}
              </Typography>
              <Typography
                variant="caption"
                sx={{ color: "#00838f", fontWeight: 600 }}
              >
                {row.leave_name}
              </Typography>
            </Box>
            <Chip
              label={row.status?.toUpperCase()}
              size="small"
              sx={{
                backgroundColor: style.bg,
                color: style.color,
                fontWeight: 700,
                borderRadius: "6px",
              }}
            />
          </Box>

          <Divider sx={{ borderColor: "#eee" }} />

          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <DateRangeIcon sx={{ fontSize: 18, color: "text.secondary" }} />
            <Typography variant="body2">
              {row.from_date} — {row.to_date}{" "}
              <strong>({row.total_days} Days)</strong>
            </Typography>
          </Box>

          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
              fontStyle: "italic",
              backgroundColor: "#f9f9f9",
              p: 1,
              borderRadius: "6px",
            }}
          >
            "{row.reason || "No reason provided"}"
          </Typography>

          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <IconButton
              size="small"
              onClick={() => {
                setSelectedLeave(row);
                setOpen(true);
              }}
              sx={{
                color: "#00bcff",
                backgroundColor: "#f0faff",
                "&:hover": { backgroundColor: "#e0f5ff" },
              }}
            >
              <VisibilityIcon fontSize="small" />
            </IconButton>

            {canCancel && (
              <IconButton
                size="small"
                onClick={() => handleCancel(row)}
                sx={{
                  color: "#d32f2f",
                  backgroundColor: "#ffebee",
                  "&:hover": { backgroundColor: "#ffcdd2" },
                }}
              >
                <CancelIcon fontSize="small" />
              </IconButton>
            )}
          </Box>
        </Stack>
      </Box>
    );
  };

  return (
    <Box
      sx={{
        width: "100%",
        p: { xs: 1.5, md: 3 },
        backgroundColor: "#f4f6f8",
        minHeight: "100vh",
      }}
    >
      {/* ---- Leave balance summary ---- */}
      <Box sx={{ mb: 3 }}>
        <Typography
          sx={{
            fontWeight: 700,
            color: "#334155",
            fontSize: "0.85rem",
            mb: 1.5,
            textTransform: "uppercase",
            letterSpacing: "0.04em",
          }}
        >
          Leave Balance
        </Typography>

        <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap" }}>
          {balanceLoading ? (
            [1, 2, 3, 4].map((i) => (
              <Skeleton key={i} variant="rounded" width={140} height={66} />
            ))
          ) : leaveBalances.length === 0 ? (
            <Typography variant="body2" sx={{ color: "#64748b" }}>
              No leave balance set up yet.
            </Typography>
          ) : (
            leaveBalances.map((b) => {
              const low = Number(b.adjusted_leaves) <= 0;
              return (
                <Box
                  key={b.leave_code}
                  sx={{
                    minWidth: 150,
                    backgroundColor: "#ffffff",
                    border: "1px solid #e0e0e0",
                    borderRadius: "10px",
                    padding: "10px 14px",
                    boxShadow: "0px 2px 4px rgba(0,0,0,0.03)",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "0.72rem",
                      fontWeight: 700,
                      color: "#64748b",
                      textTransform: "uppercase",
                      letterSpacing: "0.04em",
                    }}
                  >
                    {b.leave_name}
                  </Typography>

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "baseline",
                      gap: 0.5,
                      mt: 0.3,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "1.25rem",
                        fontWeight: 700,
                        color: "#1e293b",
                      }}
                    >
                      {Number(b.allotted_leaves)}
                    </Typography>
                    <Typography sx={{ fontSize: "0.9rem", color: "#94a3b8" }}>
                      /
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "1.25rem",
                        fontWeight: 700,
                        color: low ? "#c62828" : "#2e7d32",
                      }}
                    >
                      {Number(b.adjusted_leaves)}
                    </Typography>
                    <Typography sx={{ fontSize: "0.75rem", color: "#94a3b8" }}>
                      left
                    </Typography>
                  </Box>

                  <Typography
                    sx={{ fontSize: "0.68rem", color: "#94a3b8", mt: 0.2 }}
                  >
                    Used {b.used_leaves}
                  </Typography>
                </Box>
              );
            })
          )}
        </Box>
      </Box>

      {/* ---- Leave list ---- */}
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 10 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          {isMobile ? (
            <Grid container spacing={2}>
              {leaveData.length === 0 ? (
                <Grid item xs={12}>
                  <Paper sx={{ p: 4, textAlign: "center" }}>
                    <Typography sx={{ color: "#64748b" }}>
                      No leave records found.
                    </Typography>
                  </Paper>
                </Grid>
              ) : (
                leaveData.map((row) => (
                  <Grid item xs={12} sm={6} key={row.id}>
                    <MobileCard row={row} />
                  </Grid>
                ))
              )}
            </Grid>
          ) : (
            <TableContainer
              component={Paper}
              sx={{
                backgroundColor: "#ffffff",
                borderRadius: "12px",
                border: "1px solid #e0e0e0",
                boxShadow: "0px 4px 10px rgba(0,0,0,0.03)",
              }}
            >
              <Table>
                <TableHead sx={{ backgroundColor: "#f8f9fa" }}>
                  <TableRow>
                    {[
                      "Type",
                      "Reason",
                      "Duration",
                      "Days",
                      "Status",
                      "Action",
                    ].map((h) => (
                      <TableCell
                        key={h}
                        sx={{
                          color: "text.secondary",
                          fontWeight: 700,
                          borderBottom: "1px solid #e0e0e0",
                        }}
                      >
                        {h}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {leaveData.length === 0 ? (
                    <TableRow>
                      <TableCell
                        colSpan={6}
                        sx={{ textAlign: "center", py: 5, color: "#64748b" }}
                      >
                        No leave records found.
                      </TableCell>
                    </TableRow>
                  ) : (
                    leaveData.map((row) => {
                      const style = getStatusStyle(row.status);
                      const canCancel = row.status?.toLowerCase() !== "cancelled";

                      return (
                        <TableRow
                          key={row.id}
                          sx={{ "&:hover": { backgroundColor: "#fdfdfd" } }}
                        >
                          <TableCell sx={{ color: "#00838f", fontWeight: 600 }}>
                            {row.leave_name}
                          </TableCell>
                          <TableCell sx={{ color: "#616161" }}>
                            {row.reason
                              ? `${row.reason.substring(0, 20)}...`
                              : "—"}
                          </TableCell>
                          <TableCell sx={{ color: "#212121" }}>
                            {row.from_date} to {row.to_date}
                          </TableCell>
                          <TableCell sx={{ color: "#212121", fontWeight: 600 }}>
                            {row.total_days}
                          </TableCell>
                          <TableCell>
                            <Chip
                              label={row.status}
                              size="small"
                              sx={{
                                backgroundColor: style.bg,
                                color: style.color,
                                fontWeight: 600,
                                borderRadius: "6px",
                                textTransform: "capitalize",
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            <Tooltip title="View">
                              <IconButton
                                onClick={() => {
                                  setSelectedLeave(row);
                                  setOpen(true);
                                }}
                                sx={{
                                  color: "#00bcff",
                                  "&:hover": { backgroundColor: "#f0faff" },
                                }}
                              >
                                <VisibilityIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>

                            {canCancel && (
                              <Tooltip title="Cancel Leave">
                                <IconButton
                                  onClick={() => handleCancel(row)}
                                  sx={{
                                    color: "#d32f2f",
                                    "&:hover": { backgroundColor: "#ffebee" },
                                  }}
                                >
                                  <CancelIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    })
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}

          <TablePagination
            component="div"
            count={total}
            page={page}
            onPageChange={(e, n) => setPage(n)}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={(e) => {
              setRowsPerPage(parseInt(e.target.value, 10));
              setPage(0);
            }}
            sx={{ color: "text.secondary", mt: 2 }}
          />
        </>
      )}

      {/* ---- Details Dialog ---- */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        PaperProps={{ sx: { backgroundColor: "#ffffff", borderRadius: "12px" } }}
      >
        <DialogTitle
          sx={{ borderBottom: "1px solid #e0e0e0", fontWeight: 700 }}
        >
          Leave Details
        </DialogTitle>
        <DialogContent sx={{ p: 3 }}>
          {selectedLeave && (
            <Stack spacing={2} sx={{ mt: 2 }}>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography color="text.secondary">Employee:</Typography>
                <Typography sx={{ fontWeight: 600 }}>
                  {selectedLeave.employee_name || "—"}
                </Typography>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography color="text.secondary">Leave Type:</Typography>
                <Typography sx={{ fontWeight: 600 }}>
                  {selectedLeave.leave_name}
                </Typography>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography color="text.secondary">Duration:</Typography>
                <Typography sx={{ fontWeight: 600 }}>
                  {selectedLeave.from_date} to {selectedLeave.to_date} (
                  {selectedLeave.total_days} Days)
                </Typography>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography color="text.secondary">Status:</Typography>
                <Chip
                  label={selectedLeave.status}
                  size="small"
                  sx={{
                    backgroundColor: getStatusStyle(selectedLeave.status).bg,
                    color: getStatusStyle(selectedLeave.status).color,
                    fontWeight: 600,
                    textTransform: "capitalize",
                  }}
                />
              </Box>
              <Box>
                <Typography color="text.secondary" sx={{ mb: 0.5 }}>
                  Reason:
                </Typography>
                <Typography
                  sx={{
                    p: 1.5,
                    backgroundColor: "#f5f5f5",
                    borderRadius: "8px",
                    border: "1px solid #e0e0e0",
                    color: "#424242",
                  }}
                >
                  {selectedLeave.reason || "No reason provided"}
                </Typography>
              </Box>
            </Stack>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2, borderTop: "1px solid #e0e0e0" }}>
          {selectedLeave?.status?.toLowerCase() !== "cancelled" && (
            <Button
              onClick={() => {
                setOpen(false);
                handleCancel(selectedLeave);
              }}
              variant="contained"
              color="error"
              disableElevation
              startIcon={<CancelIcon />}
            >
              Cancel Leave
            </Button>
          )}
          <Button
            onClick={() => setOpen(false)}
            variant="contained"
            disableElevation
            sx={{
              backgroundColor: "#f0f0f0",
              color: "#424242",
              "&:hover": { backgroundColor: "#e0e0e0" },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default LeaveTable;